//  This is a generated file, do not edit it directly
import SvgIcon from '@mui/material/SvgIcon';
import type { TpBaseSvgIconProps } from '../types/muiSvgIcon';
import { SvgRadio } from '../icons/Radio';

export function RadioIcon(props: TpBaseSvgIconProps): React.ReactElement {
  return (
    <SvgIcon {...props} component={SvgRadio} data-qa="RadioIcon">
      <svg />
    </SvgIcon>
  );
}
